(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript-panel.js');
'use strict';

const {
  useEffect
} = React;
const Button = svs.ui.ReactButton;
const {
  fetchTranscriptStatus,
  orderTranscript
} = svs.myProfile.react.store.pd.actions;
const {
  getMessageByCode
} = svs.myProfile.react.shared.errorMessages;
const {
  TranscriptReadDocument,
  TranscriptOrderedDownload,
  TranscriptOrderedThankYou
} = svs.myProfile.react.pages.myInformation.transcript;
const {
  showOrderTranscriptError,
  showAboutTranscript
} = svs.myProfile.react.shared.dialogs;
const {
  ReactInfoButtonText
} = svs.tb_ui;

const TranscriptPanel = _ref => {
  let {
    isTranscriptLink
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const transcriptStatuses = ReactRedux.useSelector(state => state.playerDetails.transcriptOrderStatus);
  const customerTranscript = transcriptStatuses.find(item => item.OrderType === '1');
  const transcriptRef = React.useRef(null);
  const handleOrderClick = async () => {
    const response = await dispatch(orderTranscript('1'));
    if (response.error) {
      var _response$payload;
      const errorCode = (response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.code) || null;
      const errorText = errorCode ? getMessageByCode(errorCode) : null;
      showOrderTranscriptError(errorText);
    }
  };
  React.useEffect(() => {
    if (isTranscriptLink && transcriptRef) {
      transcriptRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isTranscriptLink]);
  useEffect(() => {
    dispatch(fetchTranscriptStatus());
  }, [dispatch]);
  return React.createElement("div", {
    className: "scroll-margin-transcript",
    ref: transcriptRef
  }, React.createElement("div", {
    className: "padding-bottom-3"
  }, React.createElement("h2", {
    className: "align-center h2 margin-bottom-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, " Registerutdrag ")), React.createElement("div", {
    className: "f-left relative"
  }, React.createElement("p", null, "Du kan best\xE4lla ett utdrag p\xE5 vilka personuppgifter som vi behandlar n\xE4r du \xE4r kund hos oss."), (customerTranscript === null || customerTranscript === void 0 ? void 0 : customerTranscript.OrderStatus) === 'READY' && React.createElement(React.Fragment, null, React.createElement(TranscriptReadDocument, null), React.createElement(TranscriptOrderedDownload, {
    customerTranscript: customerTranscript
  }), React.createElement("p", null, "Ditt registerutdrag \xE4r tillg\xE4ngligt h\xE4r p\xE5 Min profil f\xF6r nedladdning i upp till 30 dagar.", ' ', "Har du fr\xE5gor om ditt registerutdrag \xE4r du v\xE4lkommen att skicka ett e-post till dataskyddsombudet@svenskaspel.se.")), (customerTranscript === null || customerTranscript === void 0 ? void 0 : customerTranscript.OrderStatus) === 'NOTREADY' && React.createElement(TranscriptOrderedThankYou, null), !customerTranscript && React.createElement(Button, {
    block: true,
    className: "margin-v-2",
    onClick: handleOrderClick,
    size: 300,
    transparent: true
  }, "Best\xE4ll registerutdrag")), React.createElement(ReactInfoButtonText, {
    onClick: showAboutTranscript,
    text: "L\xE4s mer om registerutdrag"
  })));
};
svs.myProfile.react.pages.myInformation.transcript.TranscriptPanel = TranscriptPanel;

 })(window);